<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="">
    <div class="m-3">

        <div class="mb-3">
            <label class="fw-bold mb-2 d-block"for="" style="color: #0b095e;">Request Type</label>
            <mat-radio-group [(ngModel)]="mainOption" (change)="onMainOptionChange($event)">
                <mat-radio-button value="DOWNLOAD" class="me-4">
                    <span>Document for Download</span>
                </mat-radio-button>
                <mat-radio-button value="PRINT">
                    <span>Document for Print</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="mb-3 ps-3 border-start border-3 border-primary" *ngIf="mainOption">
            <div *ngIf="mainOption === 'DOWNLOAD'">
                <mat-radio-group [(ngModel)]="subOption" (change)="onSubOptionChange($event)"
                    class="d-flex flex-row gap-4">
                    <mat-radio-button value="DOC_REQ">Download Document</mat-radio-button>
                    <mat-radio-button value="ORIGINAL">Download Original Document</mat-radio-button>
                    <mat-radio-button value="REV_HIST">Download with Revision History</mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="mainOption === 'PRINT'">
                <mat-radio-group [(ngModel)]="subOption" (change)="onSubOptionChange($event)"
                    class="d-flex flex-row gap-4">
                    <mat-radio-button value="DOC_REQ">Document for Print</mat-radio-button>
                    <mat-radio-button value="ORIGINAL">Print Original Document</mat-radio-button>
                    <mat-radio-button value="REV_HIST">Print with Revision History</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <br *ngIf="subOption" />

        <div *ngIf="subOption">

            <div *ngIf="subOption === 'DOC_REQ'">
                <fieldset class="border rounded-4 p-2 crFieldsetStyle">
                    <legend class="float-none w-auto p-2" style="margin-bottom: 0px">
                        <span class="" style="font-size: 14px; color: #cfcfcf">Details</span>
                    </legend>

                    <div class="row d-flex">
                        <div class="col-md-3">
                            <label for="">Download Template <span class="mandatory-symbol">*</span></label>
                            <mat-select class="input-filed-continers" placeholder="Select"
                                [(ngModel)]="selectedTemplate" (selectionChange)="onTemplateSelect($event)">
                                <mat-option *ngFor="let item of templateList" [value]="item.id">
                                    {{ item.name }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-md-3">
                            <label for="">Issuance Type <span class="mandatory-symbol">*</span></label>
                            <mat-select class="input-filed-continers" placeholder="Select"
                                [(ngModel)]="documentIssuanceType" (closed)="issuanceTypeSearchText=''"
                                (click)="focusSearch('focus-issuance-type-search')">
                                <input type="search" id="focus-issuance-type-search" class="dropdownsearchstyle"
                                    [(ngModel)]="issuanceTypeSearchText" matInput placeholder="search">
                                <mat-option
                                    *ngFor="let item of documentIssuanceTypeDropdown | assessmentSearch : issuanceTypeSearchText"
                                    [value]="item.valueExp" (onSelectionChange)="documentIssuanceSelect($event,item)">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>

                        <div class="col-md-3">
                            <label for="">Issued to</label>
                            <input type="text" [(ngModel)]="issuanceTo" class="input-filed-continers" />
                        </div>

                        <div class="col-md-3">
                            <label for="">Prints/Copies <span class="mandatory-symbol"
                                    *ngIf="mainOption === 'PRINT'">*</span></label>
                            <input type="number" min="1" [(ngModel)]="issuanceCopy" class="input-filed-continers" />
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-8">
                            <label for="">Watermark</label>
                            <div class="d-flex">
                                <textarea type="text" [(ngModel)]="documentWatermark" rows="2"
                                    class="input-filed-continers"></textarea>
                                <input style="width: 40px; margin-left:5px;" [(colorPicker)]="watermarkColor"
                                    [style.background]="watermarkColor" />
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="">Verifier <span class="mandatory-symbol">*</span></label>
                            <mat-select class="input-filed-continers" placeholder="Select"
                                [(ngModel)]="selectedVerifier">
                                <input type="search" class="dropdownsearchstyle" [(ngModel)]="verifierSearchText"
                                    matInput placeholder="search">

                                <mat-option *ngFor="let item of verifierList | assessmentSearch : verifierSearchText"
                                    [value]="item.id">
                                    {{ item.name }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-6">
                            <label for="">Reason for Request <span class="mandatory-symbol">*</span></label>
                            <textarea rows="2" class="input-filed-continers" [(ngModel)]="requestReason"></textarea>
                        </div>
                        <div class="col-md-3">
                            <label for="">Department <span class="mandatory-symbol">*</span></label>
                            <mat-select class="input-filed-continers" placeholder="Select"
                                [(ngModel)]="selectedDepartment">
                                <input type="search" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
                                    matInput placeholder="search">
                                <mat-option
                                    *ngFor="let item of departmentList | assessmentSearch : departmentSearchText"
                                    [value]="item.id">
                                    {{ item.name }}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div class="col-md-3">
                            <label for="">Report Logo</label>
                            <mat-select class="input-filed-continers" placeholder="Select"
                                [(ngModel)]="selectedReportLogoValue" (closed)="pdfDetailSearchText=''"
                                (click)="focusSearch('focus-Logo-search')">
                                <input type="search" id="focus-Logo-search" class="dropdownsearchstyle"
                                    [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">
                                <mat-option [value]="null">Un-select</mat-option>
                                <mat-option
                                    *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
                                    [value]="item.valueExp" (onSelectionChange)="onReportLogoValueSelect($event,item)">
                                    {{ item.displayExp }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border p-2 crFieldsetStyle mt-3">
                    <legend class="float-none w-auto p-2" style="margin-bottom: 0px">
                        <span class="" style="font-size: 14px; color: #cfcfcf; margin-bottom: 0px">Include</span>
                    </legend>
                    <div class="row d-flex">
                        <div class="col-md-8">
                            <div class="d-flex gap-3">
                                <div class="col-md-3">
                                    <mat-checkbox color="primary" [(ngModel)]="incudeCoverPgae"
                                        (change)="toggleChanged($event)"><span>Cover
                                            Page</span></mat-checkbox>
                                    <input class="input-filed-continers" type="text" placeholder="Cover Page"
                                        [(ngModel)]="incudeCoverPgaeTitle" [disabled]="!incudeCoverPgae" />
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox color="primary"
                                        [(ngModel)]="incudeAmendment"><span>Amendment</span></mat-checkbox>
                                    <input class="input-filed-continers" type="text" placeholder="Amendment"
                                        [(ngModel)]="incudeAmendmentTitle" [disabled]="!incudeAmendment" />
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox color="primary" [(ngModel)]="incudeApproval"
                                        (change)="onApprovalToggleChanged($event)"><span>Approval</span></mat-checkbox>
                                    <input class="input-filed-continers" type="text" placeholder="Approval"
                                        [(ngModel)]="incudeApprovalTitle" [disabled]="!incudeApproval" />
                                </div>
                                <div class="col-md-2 align-self-center mt-3">
                                    <label for="">On Last Page</label>
                                    <mat-slide-toggle color="primary" [(ngModel)]="onLastPage"
                                        [disabled]="isShowOnLatestTopDisabled">
                                        <span class="active-inActive-container" *ngIf="onLastPage"
                                            style="color: green;">Yes</span>
                                        <span *ngIf="!onLastPage" style="color: red;">No</span>
                                    </mat-slide-toggle>
                                </div>
                            </div>
                            <div class="d-flex gap-3 mt-2">
                                <div class="col-md-3">
                                    <mat-checkbox color="primary" [(ngModel)]="incudeRevisionhistory"><span>Revision
                                            History</span></mat-checkbox>
                                    <input class="input-filed-continers" type="text" placeholder="Revision History"
                                        [(ngModel)]="incudeRevisionhistoryTitle" [disabled]="!incudeRevisionhistory" />
                                </div>
                                <div class="d-flex gap-4 mb-3" *ngIf="incudeRevisionhistory">
                                    <div>
                                        <label for="">Complete History</label>
                                        <div>
                                            <mat-slide-toggle color="primary" [(ngModel)]="completeHistory">
                                                <span class="active-inActive-container" *ngIf="completeHistory"
                                                    style="color: green;">Yes</span>
                                                <span *ngIf="!completeHistory" style="color: red;">No</span>
                                            </mat-slide-toggle>
                                        </div>
                                    </div>
                                    <div *ngIf="!completeHistory">
                                        <label for="">Total Years</label>
                                        <input class="input-filed-continers" type="number" placeholder="Years" min="0"
                                            [(ngModel)]="historyYear" (keypress)="validateYear($event)" />
                                    </div>
                                    <div class="align-self-end" *ngIf="historyYear != null">
                                        <mat-checkbox color="primary" [(ngModel)]="isLatestOnTop"><span>Latest on
                                                top</span></mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div class="d-flex justify-content-between mt-3">
                                <mat-checkbox color="primary"
                                    [(ngModel)]="incudeFooter"><span>Footer</span></mat-checkbox>
                                <mat-checkbox color="primary" [(ngModel)]="incudePageNo"><span>Page
                                        No</span></mat-checkbox>
                            </div>
                            <div class="d-flex justify-content-between mt-3">
                                <mat-checkbox color="primary"
                                    [(ngModel)]="publisherDetails"><span>Publisher</span></mat-checkbox>
                                <mat-checkbox color="primary" [(ngModel)]="linkedDocuments"><span>Linked
                                        Docs</span></mat-checkbox>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mt-3">
                                <mat-checkbox color="primary"
                                    [(ngModel)]="incudeNotes"><span>Notes</span></mat-checkbox>
                                <input class="input-filed-continers ms-2" type="text" placeholder="Notes"
                                    [(ngModel)]="incudeNotesTitle" [disabled]="!incudeNotes" />
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div *ngIf="subOption === 'ORIGINAL'">
                <div class="row">
                    <div class="col-md-4">
                        <label for="">Verifier <span class="mandatory-symbol">*</span></label>
                        <mat-select class="input-filed-continers" placeholder="Select" [(ngModel)]="selectedVerifier">
                            <input type="search" class="dropdownsearchstyle" [(ngModel)]="verifierSearchText" matInput
                                placeholder="search">
                            <mat-option *ngFor="let item of verifierList | assessmentSearch : verifierSearchText"
                                [value]="item.id">{{ item.name }}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-4">
                        <label for="">Reason for Request <span class="mandatory-symbol">*</span></label>
                        <textarea rows="2" class="input-filed-continers" [(ngModel)]="requestReason"></textarea>
                    </div>
                    <div class="col-md-4">
                        <label for="">Department <span class="mandatory-symbol">*</span></label>
                        <mat-select class="input-filed-continers" placeholder="Select" [(ngModel)]="selectedDepartment">
                            <input type="search" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText" matInput
                                placeholder="search">
                            <mat-option *ngFor="let item of departmentList | assessmentSearch : departmentSearchText"
                                [value]="item.id">{{ item.name }}</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>

            <div *ngIf="subOption === 'REV_HIST'">
                <div class="d-flex gap-4 mb-3">
                    <div>
                        <label for="">Complete History</label>
                        <div>
                            <mat-slide-toggle color="primary" [(ngModel)]="completeHistory">
                                <span class="active-inActive-container" *ngIf="completeHistory"
                                    style="color: green;">Yes</span>
                                <span *ngIf="!completeHistory" style="color: red;">No</span>
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <div *ngIf="!completeHistory">
                        <label for="">Total Years</label>
                        <input class="input-filed-continers" type="number" placeholder="Years" min="0"
                            [(ngModel)]="historyYear" (keypress)="validateYear($event)" />
                    </div>
                    <div class="align-self-end" *ngIf="historyYear != null">
                        <mat-checkbox color="primary" [(ngModel)]="isLatestOnTop"><span>Latest on
                                top</span></mat-checkbox>
                    </div>
                </div>

                <hr>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="">Watermark</label>
                        <div class="d-flex">
                            <textarea rows="3" class="input-filed-continers" [(ngModel)]="documentWatermark"></textarea>
                            <input style="width: 40px; margin-left: 5px;" [(colorPicker)]="watermarkColor"
                                [style.background]="watermarkColor" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="">Comments</label>
                        <textarea rows="3" class="input-filed-continers" [(ngModel)]="comments"></textarea>
                    </div>
                    <div class="col-md-4">
                        <label for="">Downloaded Doc Name</label>
                        <textarea rows="3" class="input-filed-continers"
                            [(ngModel)]="documentNameForDownload"></textarea>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-md-4">
                        <label for="">Verifier <span class="mandatory-symbol">*</span></label>
                        <mat-select class="input-filed-continers" placeholder="Select" [(ngModel)]="selectedVerifier">
                            <input type="search" class="dropdownsearchstyle" [(ngModel)]="verifierSearchText" matInput
                                placeholder="search">
                            <mat-option *ngFor="let item of verifierList | assessmentSearch : verifierSearchText"
                                [value]="item.id">{{ item.name }}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-4">
                        <label for="">Reason for Request <span class="mandatory-symbol">*</span></label>
                        <textarea rows="2" class="input-filed-continers" [(ngModel)]="requestReason"></textarea>
                    </div>
                    <div class="col-md-4">
                        <label for="">Department <span class="mandatory-symbol">*</span></label>
                        <mat-select class="input-filed-continers" placeholder="Select" [(ngModel)]="selectedDepartment">
                            <input type="search" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText" matInput
                                placeholder="search">
                            <mat-option *ngFor="let item of departmentList | assessmentSearch : departmentSearchText"
                                [value]="item.id">{{ item.name }}</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>

        </div>

        <div class="border-top mt-4">
            <div class="button-continer d-flex gap-3 justify-content-end py-2">
                <button mat-stroked-button class="training_btn d-flex gap-1 align-items-center" (click)="onSubmit()">
                    Submit Request
                </button>
                <button mat-stroked-button class="cancelButton" (click)="cancel()">
                    <i class="fa fa-close"></i> Cancel
                </button>
            </div>
        </div>

    </div>
</div>